import { handleActions } from 'redux-actions';
import * as ActionTypes from '../actions/actionTypes';

const initialState = {
  isAlertVisible: false,
  alertMessage: null,
  isConfirmVisible: false,
  confirmMessage: null,
  confirmAction: null,
  uiProps: {
    cancelButtonLabel: 'Cancel',
    proceedButtonLabel: 'Ok'
  }
};

export default handleActions({
  [ActionTypes.UI_SHOW_ALERT]: (state, action) => ({
    ...state,
    isAlertVisible: true,
    alertMessage: action.message
  }),
  [ActionTypes.UI_HIDE_ALERT]: (state) => ({
    ...state,
    isAlertVisible: false
  }),
  [ActionTypes.UI_SHOW_CONFIRM]: (state, action) => ({
    ...state,
    isConfirmVisible: true,
    confirmMessage: action.message,
    confirmAction: action.confirmAction,
    uiProps: {
      ...state.uiProps,
      ...action.uiProps
    }
  }),
  [ActionTypes.UI_HIDE_CONFIRM]: (state) => ({
    ...state,
    isConfirmVisible: false,
    uiProps: initialState.uiProps
  })
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/ui.js